/** @jsxImportSource @emotion/react */

import Typography from '@mui/material/Typography'
import { findAllAdmissionExpert_findAllAdmissionExpert_items as AdmissionExpert } from '__generatedTypes__/findAllAdmissionExpert'
import { TableProps } from 'components/Table'
import * as classes from 'pagesNew/TeamMembers/TeamMembersList/styles'
import * as commonClasses from 'components/shared/GroupCards/commonStyles'
import { getImageByDimensions } from 'utils/getImageByDimensions'
import { ReactComponent as EditIcon } from 'assets/icons/edit.svg'

export const getColumns = (handleEditClick: (expert: AdmissionExpert) => void) => {
  const columns: TableProps<AdmissionExpert & { index: number }>['columns'] = [
    {
      title: '#',
      renderCell: (expert) => (
        <Typography variant="body2" css={classes.index}>
          {expert.index + 1}
        </Typography>
      ),
      flex: '0 1 30px',
    },
    {
      renderCell: (expert) => (
        <div css={classes.avatar}>
          <img
            css={classes.avatar}
            src={getImageByDimensions(expert.getAvatar.photo || '', 50, 50)}
            alt="Team member avatar"
          />
        </div>
      ),
      flex: '0 1 31px',
    },
    {
      title: 'Name',
      renderCell: (expert) => (
        <Typography variant="body2" css={commonClasses.longText}>
          {expert.name}
        </Typography>
      ),
      flex: '1',
    },
    {
      title: 'Degree',
      renderCell: (expert) => (
        <Typography css={commonClasses.longText} variant="body2">
          {expert.degree}
        </Typography>
      ),
      flex: '1',
    },
    {
      title: 'Description',
      renderCell: (expert) => (
        <Typography css={commonClasses.longText} variant="body2">
          {expert.description}
        </Typography>
      ),
      flex: '1',
    },
    {
      title: 'Email',
      renderCell: (expert) => (
        <Typography css={commonClasses.longText} variant="body2">
          {expert.email}
        </Typography>
      ),
      flex: '1',
    },
    {
      renderCell: (member) => <EditIcon css={classes.editIcon} onClick={() => handleEditClick(member)} />,
      flex: '0 1 29px',
    },
  ]

  return columns
}
